"use client";

import { useEffect } from "react";

/**
 * Inject Cookiebot after hydration. Auto-blocking mode rewrites script tags and
 * patches fetch(); if that runs while Next is still streaming the RSC payload,
 * the client reports "Connection closed" and the router wedges.
 */
export function CookiebotScript({ cookiebotId }: { cookiebotId: string }) {
  useEffect(() => {
    if (document.getElementById("Cookiebot")) {
      return;
    }

    const script = document.createElement("script");
    script.id = "Cookiebot";
    script.src = "https://consent.cookiebot.com/uc.js";
    script.async = true;
    script.setAttribute("data-cbid", cookiebotId);
    script.setAttribute("data-blockingmode", "auto");
    document.head.appendChild(script);
  }, [cookiebotId]);

  return null;
}
